// packages block
import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, Typography } from "@material-ui/core";
// common block
import "./style.css";
import { FormButton } from "../form";
import { preaddStyles } from "./styles";
// constants, theme, utils and api block
import { BLUE_EIGHT, ORANGE_TWO, WHITE } from "../../theme";

export const StudentConfirmationDeleteDialog = ({
  open,
  close,
  handleDelete,
  loading,
  title,
}) => {
  const { t } = useTranslation();
  const classes = preaddStyles();

  return (
    <Dialog
      className={classes.root}
      // onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <div className="confirmation_card">
        <Typography variant="h3" style={{ textAlign: 'center', marginBottom: 20 }} >
          {title === t("text_school") && t("text_delete_school")}
          {title === t("text_student") && t("text_delete_students")}
          {title === t("text_user") && t("text_delete_user")}
          {title === t("text_bank") && t("text_delete_bank")}
        </Typography>
        <Typography variant="h5" style={{ textAlign: 'center', color: 'gray' }} >
          {title === t("text_school") &&
            t("text_this_will_delete_the_school_do_you_still_want_to_proceed")}
          {title === t("text_user") &&
            t("text_this_will_delete_the_use_do_you_want_to_proceed")}
          {title === t("text_student") &&
            t("text_this_will_delete_all_student's_data_including_student's_invoices_details_and_payment_history_do_you_still_want_to_proceed")}
          {title === t("text_bank") &&
            t("text_this_will_delete_the_account_do_you_want_to_proceed")}
        </Typography>

        <div className="confirmation_buttons">
          <div className="btn1">
            <FormButton
              title={t("text_cancel")}
              backgroundColor={ORANGE_TWO}
              borderColor={ORANGE_TWO}
              titleColor={WHITE}
              hoverBackgroundColor={WHITE}
              hoverBorderColor={ORANGE_TWO}
              hoverTitleColor={ORANGE_TWO}
              height={40}
              width={"10vw"}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
              style={{ fontSize: "0.8vw", fontWeight: "700" }}
              onClickHandler={close}
            />
          </div>

          <div className="btn1">
            <FormButton
              height={40}
              width={"10vw"}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
              backgroundColor={BLUE_EIGHT}
              titleColor={WHITE}
              hoverTitleColor={BLUE_EIGHT}
              hoverBackgroundColor={WHITE}
              hoverBorderColor={BLUE_EIGHT}
              title={t("text_confirm")}
              loading={loading}
              style={{ fontSize: "0.8vw", fontWeight: "700" }}
              loadingColor={"#F8966A"}
              onClickHandler={handleDelete}
            />
          </div>
        </div>
      </div>
    </Dialog >
  );
};
